import React, { createContext, useContext, useState } from "react"

import native from "../../native/native"

interface State {
  showPlanSheet: boolean
  showFeaturesSheet: boolean
}

interface Actions {
  setShowPlanSheet: (show: boolean) => void
  setShowFeaturesSheet: (show: boolean) => void
}

interface Context {
  state: State
  actions: Actions
}

const FreeTrialPaywallContext = createContext<Context | null>(null)

const FreeTrialPaywallProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [showPlanSheet, setShowPlanSheetInternal] = useState(false)
  const [showFeaturesSheet, setShowFeaturesSheetInternal] = useState(false)

  const eventName = "html_free_trial_popup"

  const setShowPlanSheet = (value: boolean) => {
    if (value) {
      native.logMixpanelEvent(eventName, { type: "plans" })
    }

    setShowPlanSheetInternal(value)
  }

  const setShowFeaturesSheet = (value: boolean) => {
    if (value) {
      native.logMixpanelEvent(eventName, { type: "features" })
    }

    setShowFeaturesSheetInternal(value)
  }

  const state: State = {
    showPlanSheet,
    showFeaturesSheet,
  }

  const actions: Actions = {
    setShowPlanSheet,
    setShowFeaturesSheet,
  }

  return (
    <FreeTrialPaywallContext.Provider value={{ state, actions }}>
      {children}
    </FreeTrialPaywallContext.Provider>
  )
}

const useFreeTrialPaywall = () => {
  const context = useContext(FreeTrialPaywallContext)

  if (!context) {
    throw new Error(
      "useFreeTrialPaywallProvider has to be used within <FreeTrialPaywallContext.Provider>"
    )
  }

  return context
}

export { FreeTrialPaywallProvider, FreeTrialPaywallContext, useFreeTrialPaywall }
